/**
 * 로그인 시 서버(tb_ics_refresh_token)에 저장되는 userGuid 값을 만들어내는 함수.
 */
export const getGuid = () => {
    const nav = window.navigator;
    const screen = window.screen;

    let guid = nav.mimeTypes.length;
    guid += nav.userAgent.replace(/\D+/g, "");
    guid += nav.plugins.length;
    guid += screen.height || "";
    guid += screen.width || "";
    guid += screen.pixelDepth || "";

    return String(guid);
};
